import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  events: [],
  eventsCount: 0,
  imageCount: 0,
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    fetcheventsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.successMessage = "";
    },
    fetcheventsSuccess: (state, action) => {
      state.loading = false;
      state.events = action.payload.events;
      state.eventsCount = action.payload.totalEvents;
      state.imageCount = action.payload.totalImages;
    },
    fetcheventsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.successMessage = "";
    },
    createEventsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.successMessage = "";
    },
    createEventsSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.success = true;
      state.events.push(action.payload.event);
      state.eventsCount += 1;
      state.imageCount += action.payload.event.totalPhotos || 0;
    },
    createEventsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.successMessage = "";
    },
  },
});

export const {
  fetcheventsRequest,
  fetcheventsSuccess,
  fetcheventsFailure,
  createEventsRequest,
  createEventsSuccess,
  createEventsFailure,
} = eventsSlice.actions;

export default eventsSlice.reducer;
